var map = {
	"./aquario.json": "kU8E",
	"./aries.json": "LPC8",
	"./cancer.json": "Puoi",
	"./capricornio.json": "vRzA",
	"./escorpiao.json": "N01Y",
	"./gemeos.json": "y1Hr",
	"./leao.json": "gZ8/",
	"./libra.json": "38lL",
	"./peixes.json": "GbRQ",
	"./sagitario.json": "Ppum",
	"./touro.json": "eSQw",
	"./virgem.json": "cmdq"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "xmWv";